var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useContext, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { BanUserModal, } from 'components/shared/banUserModal/banUserModal';
import { UnbanUserModal } from 'components/shared/unbanUserModal/unbanUserModal';
import { UserBanOnChatContext } from '../../../../../../userDetails';
const unbanOnChatLabel = 'Unban on chat';
const banOnChatLabel = 'Ban on chat';
export function BanUnbanContactAction({ user, toggleDropdown, }) {
    const [isBanModalOpen, setIsBanModalOpen] = useState(false);
    const [isUnbanModalOpen, setIsUnbanModalOpen] = useState(false);
    const { isBanned, onBanStatusToggle, isLoadingBanStatus } = useContext(UserBanOnChatContext);
    const handleClick = () => __awaiter(this, void 0, void 0, function* () {
        if (isBanned) {
            analytics.contactsUnbanUserClicked({
                channel: 'widget_chat',
            });
            setIsUnbanModalOpen(true);
        }
        else {
            analytics.contactsBanUserClicked({
                channel: 'widget_chat',
            });
            setIsBanModalOpen(true);
        }
        toggleDropdown();
    });
    const handleModalClose = (event) => {
        setIsBanModalOpen(false);
        setIsUnbanModalOpen(false);
        if (event.response) {
            onBanStatusToggle === null || onBanStatusToggle === void 0 ? void 0 : onBanStatusToggle();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: handleClick, isLoading: isLoadingBanStatus, icon: "ban" }, { children: isBanned ? unbanOnChatLabel : banOnChatLabel })), _jsx(BanUserModal, { user: user, channel: 'widget_chat', isOpen: isBanModalOpen, onClose: handleModalClose }), _jsx(UnbanUserModal, { user: user, channel: 'widget_chat', isOpen: isUnbanModalOpen, onClose: handleModalClose })] }));
}
